export class OfferKey {
  campaignKey: string;
  couponId: string | null;
}
